// Import helpers
import { getUrlSearch } from '../helpers';
import { obfuscate, deobfuscate } from 'helpers/localstorage';
import SearchParams from 'components/utilities/hooks/search_params/SearchParams';

/*
	showAlways
		- If true, the store will always be shown in the URL
		- If false, the store will only be shown when there is a search query
		(restore configurator after external redirect like myID or BlueMedia)
*/
export const QueryParamStore = (showAlways = false) => {
	const searchQueryString = window.location.search.length
		? window.location.search.slice(1)
		: '';
	const urlSearch = new URLSearchParams(searchQueryString);
	const searchParams = new SearchParams(urlSearch, window.location);
	return {
		getItem: (key) => {
			if (getUrlSearch() || showAlways) {
				try {
					const storedValue = searchParams.get(key).asString();
					return JSON.parse(deobfuscate(storedValue));
				} catch {
					searchParams.reset();
				}
			}
		},
		setItem: (key, newValue) => {
			if (getUrlSearch() || showAlways) {
				searchParams.set(key, obfuscate(newValue));
			}
		},
		removeItem: (key) => {
			searchParams.delete(key);
		}
	};
};
